<template>
  <hr>
</template>

<script>
export default {
  name: 'ContentHorizontalRule',

  props: [
    'obj'
  ]
}
</script>

<style scoped>
</style>
